import { render, staticRenderFns } from "./BasicInfoPurchase.vue?vue&type=template&id=395e0d70&"
import script from "./BasicInfoPurchase.vue?vue&type=script&lang=js&"
export * from "./BasicInfoPurchase.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoPurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports